import { ChakraProvider } from "@chakra-ui/react";
import { getMessaging, onMessage } from "@firebase/messaging";
import 'core-js/features/string/replace-all';
import { NextPage } from "next";
import { ReactElement, ReactNode, useEffect } from "react";
import 'react-datepicker/dist/react-datepicker.css';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { NotificationContainer } from "react-notifications";
import "react-notifications/lib/notifications.css";
import { RecoilRoot } from "recoil";
import "../assets/styles/global.css";
import { AuthProvider } from "../components/context/AuthContext";
import Layout from "../components/layout";
import firebase from "../firebase/Firebase";
import { createNotification } from "../lib/notification";


type NextPageWithLayout = NextPage & {
  getLayout?: (page: ReactElement) => ReactNode
}

const MyApp = ({
  Component, pageProps: { session, ...pageProps
}} : {
  Component: NextPageWithLayout, pageProps: any
}) => {

  const getLayout = Component.getLayout || ((page) => (<Layout>{page}</Layout>))

  useEffect(() => {
    const messaging = getMessaging(firebase)
    onMessage(messaging, (payload) => {
      createNotification('success', '新規メッセージが届きました。')
    });
  })

  return (
    <ChakraProvider>
      <RecoilRoot>
        <DndProvider backend={HTML5Backend}>
          <AuthProvider>
            { getLayout(<>
              <NotificationContainer />
                <Component {...pageProps} />
            </>)}
          </AuthProvider>
        </DndProvider>
      </RecoilRoot>
    </ChakraProvider>
  );
};

export default MyApp;
